import { ajax } from '../../utils/fetch';

import { statusMsg } from '../../utils/utils';
import LandingHeader from './landingHeaderComponent';
import LandingBanner from './landingBannerComponent';
import LandingAboutUs from './landingAboutUsComponent';
import LandingPageCourses from './landingCoursesComponent';
import LandingContactUs from './landingContactUsComponent';
import LandingSignUp from './landingSignUpComponent';
import LandingFooter from './landingFooterComponent';
import Crop from '../popup/cropComponent';

const templateCropPopup = document.createElement('template');

templateCropPopup.innerHTML = `<section class="popup crop-popup" id="crop-popup" content="">
                           <div class="crop-content">
                           <div class="crop-body"></div>
                           <div class="crop-footer"></div>
                           </div>
                           </section>`;

const templateStatusBox = document.createElement('template');
templateStatusBox.innerHTML = `<div class="voice-box">
                                        <span></span>
                                  </div>`;

export default class LandingPage extends HTMLElement {
  constructor() {
    super();

    this._root = this;
  }

  static get observedAttributes() {
    return ['semanticname', 'mode'];
  }

  set semanticname(val) {
    if (val) this.setAttribute('semanticname', val);
  }

  get semanticname() {
    return this.getAttribute('semanticname');
  }

  set mode(val) {
    if (val) this.setAttribute('mode', val);
  }

  get mode() {
    return this.getAttribute('mode');
  }

  connectedCallback() {
    // this.appendChild(document.createElement('au-crop'));
    this.appendChild(templateStatusBox.content.cloneNode(true));
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'semanticname' && newVal) {
      this._fetchUniversityDetails(newVal).then(response => {
        if (response.status) {
          this._createLandingComponents(newVal, response.data.university);
        } else {
          statusMsg(response.msg, 'warning');
        }
      });
    }
    if (name === 'mode' && newVal) {
      // this._bindEvents(newVal);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async _fetchUniversityDetails(semanticName) {
    try {
      const request = {};
      request.contentType = 'application/json; charset=utf-8';
      request.method = 'GET';
      request.url = `/api/v1/university/${semanticName}`;

      return await ajax(request);
    } catch (e) {
      console.error(`Error while fetching university details :: ${e.message}`);
    }
    return {};
  }

  _createLandingComponents(semanticName, university) {
    try {
      // Header
      const landingHeader = document.createElement('au-landing-header');
      this.appendChild(landingHeader);
      landingHeader._name = university.name ? university.name : '';
      landingHeader._image = university.image ? university.image : '';
      landingHeader.setAttribute('semanticname', semanticName);

      // Banner
      const landingBanner = document.createElement('au-landing-banner');
      this.appendChild(landingBanner);
      landingBanner._bannerImage = university.bannerImage;
      landingBanner.setAttribute('semanticname', semanticName);

      // AboutUs
      const landingAboutUs = document.createElement('au-landing-aboutus');
      this.appendChild(landingAboutUs);
      landingAboutUs._aboutUs = university.description
        ? university.description
        : '';
      landingAboutUs.setAttribute('semanticname', semanticName);

      // courses & contactus and then append footer
      this._appendCourseContactFooter(semanticName);
    } catch (e) {
      console.error(`Error while creating landing components :: ${e.message}`);
    }
  }

  _bindEvents(mode) {
    if (mode === 'view') {
      this.querySelectorAll('.editable').forEach(editable => {
        editable.removeAttribute('contenteditable');
      });
    }

    this.querySelectorAll('[semanticName]').forEach(each => {
      each.setAttribute('mode', mode);
    });
  }

  async _appendCourseContactFooter(semanticName) {
    try {
      const courseRequest = {};
      courseRequest.contentType = 'application/json; charset=utf-8';
      courseRequest.method = 'GET';
      courseRequest.url = `/api/v1/university/${semanticName}/landing/courses?limit=4&offset=0`;

      const courseResp = await ajax(courseRequest);

      const contactRequest = {};
      contactRequest.contentType = 'application/json; charset=utf-8';
      contactRequest.method = 'GET';
      contactRequest.url = `/api/v1/university/${semanticName}/subUniversity/contact`;

      const contactResp = await ajax(contactRequest);

      this._renderCourseContactFooter(courseResp, contactResp, semanticName);
    } catch (e) {
      console.error(
        `Error while appending course contact footer :: ${e.message}`
      );
    }
  }

  _renderCourseContactFooter(courseResp, contactResp, semanticName) {
    try {
      this._createCourseComponent(courseResp, semanticName);
      this._createSignupComponent();
      this._createContactUsComponent(contactResp, semanticName);

      const landingFooter = document.createElement('au-landing-footer');
      landingFooter.setAttribute('semanticname', semanticName);
      this.appendChild(landingFooter);

      this._bindEvents(this.getAttribute('mode'));
    } catch (e) {
      console.error(
        `Error while rendering course contact footer :: ${e.message}`
      );
    }
  }

  _createCourseComponent(response, semanticName) {
    try {
      if (response.status) {
        if (
          response.data &&
          response.data.courses &&
          Object.keys(response.data.courses).length > 0
        ) {
          const landingCourses = document.createElement('au-landing-courses');
          landingCourses._coursesList = response.data.courses;
          this.appendChild(landingCourses);
          landingCourses.setAttribute('semanticname', semanticName);
        }
      }
    } catch (e) {
      console.error(`Error while creating course component :: ${e.message}`);
    }
  }

  _createSignupComponent() {
    try {
      if (this.getAttribute('mode') === 'view') {
        const landingSignUp = document.createElement('au-landing-signup');
        this.appendChild(landingSignUp);
      }
    } catch (error) {
      console.error(
        `Error while creating signup component :: ${error.message}`
      );
    }
  }

  _createContactUsComponent(response, semanticName) {
    try {
      if (response.status) {
        if (response.data) {
          const contactDetails = response.data.subUniversity
            ? response.data.subUniversity.contactDetails
            : '';
          if (contactDetails || this.getAttribute('mode') === 'edit') {
            const landingContactUs = document.createElement(
              'au-landing-contactus'
            );
            landingContactUs._contactDetails = contactDetails;
            this.appendChild(landingContactUs);
            landingContactUs.setAttribute('mode', this.getAttribute('mode'));
            landingContactUs.setAttribute('semanticname', semanticName);
          }
        }
      }
    } catch (e) {
      console.error(`Error while creating contactus component :: ${e.message}`);
    }
  }
}
window.customElements.define('au-landing-header', LandingHeader);
window.customElements.define('au-landing-banner', LandingBanner);
window.customElements.define('au-landing-aboutus', LandingAboutUs);
window.customElements.define('au-landing-courses', LandingPageCourses);
window.customElements.define('au-landing-contactus', LandingContactUs);
window.customElements.define('au-landing-signup', LandingSignUp);
window.customElements.define('au-landing-footer', LandingFooter);
window.customElements.define('au-crop', Crop);
